<template>
    <div class="form-group col-md">
      <label for="filter-category" class="sr-only">Filter by Category</label>
                <select id="filter-category" class="form-control" name="category" v-model="selectedCategory">
                    <option value="" selected="selected">Filter by Category</option>
                    <option v-for="category in categoryList.results"
                            v-bind:key="category">
                    {{category.categoryName}}
                    </option>
                </select>
            </div>
</template>

<script>
  export default {
    props: ['initial','categoryList'],
    data: function () {
      return {
        selectedCategory: "",
      };
    },
    watch: {
      selectedCategory: function (newCategory) {
        if(this.initial !== newCategory) {
        // console.log('new initial value 1');
          this.$emit('change:categoryfilter', newCategory);
        }        
      },  
      initial: function() {
        // console.log('new initial value 2');
        console.log('[cat:watch] initial changed:' , this.initial);
        if(this.initial != this.selectedCategory) {
          this.selectedCategory = this.initial;
        }
      }
    },
    mounted: function() {
        // console.log('new initial value 3');
        console.log('[cat:mounted] initial changed:' , this.initial);
      if(this.initial) { 
        this.selectedCategory = this.initial;
      }
    }
  }
</script>